// @flow

import { type EmployeesState } from "@modules/employee/reducer";
import { transformSort } from "@transformers/sort";
import { startRequest, finishRequest } from "@store/utils";

export const setLoading = (state: EmployeesState) => () => ({
  ...state,
  employee: {
    ...startRequest(state.employee),
  },
});

export const stopLoading = (state: EmployeesState) => () => ({
  ...state,
  employee: {
    ...finishRequest(state.employee),
  },
});

export const onGetEmployeeReferralHistorySuccess = (state: EmployeesState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    employee: {
      ...finishRequest(state.employee),
      referralHistory: payload,
    },
  };
};

export const onSetEmployeesDefaultData = (state: EmployeesState) => ({ payload }: Object) => {
  return {
    ...state,
    employee: {
      ...state.employee,
      list: {
        content: [],
        pagination: {
          sort: {
            orders: [
              {
                direction: "ASC",
                property: "last_name",
              },
            ],
          },
          pageNumber: 0,
          pageSize: 0,
          offset: 0,
        },
        totalElements: 0,
      },
    },
  };
};
export const onSelectBespokeRecipient = (state: EmployeesState) => ({ payload }: Object) => {
  return {
    ...state,
    employee: {
      ...state.employee,
      bespokeRecipient: payload,
    },
  };
};

export const onGetEmployeesSuccess = (state: EmployeesState) => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    employee: {
      ...finishRequest(state.employee),
      list: payload,
    },
  };
};
export const onGetCurrentEmployeeSuccess = (state: EmployeesState) => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    employee: {
      ...state.employee,
      current: payload,
    },
  };
};

export const onGetEmployeesError = (state: EmployeesState) => ({ payload }: Object) => ({
  ...state,
  error: payload,
  employee: {
    ...finishRequest(state.employee),
    list: {
      ...state.employee.list,
      content: [],
    },
  },
});

export const onGetEmployeesSecurityQuestionsSuccess = (state: EmployeesState) => ({
  payload,
}: Object) => ({
  ...state,
  error: null,
  employee: {
    ...finishRequest(state.employee),
    modals: {
      ...state.employee.modals,
      addEmployee: {
        ...state.employee.modals.addEmployee,
        employeesSecurityQuestions: payload,
      },
    },
  },
});

export const onGetEmployeesSecurityQuestionsError = (state: EmployeesState) => ({
  payload,
}: Object) => ({
  ...state,
  error: payload,
  employee: {
    ...finishRequest(state.employee),
    list: {
      ...state.employee.list,
      content: [],
    },
  },
});

export const onUpdateEmployeeDraft = (state: EmployeesState) => ({
  payload,
}: $Exact<{ action: string, payload: Object }>) => {
  return {
    ...state,
    employee: {
      ...state.employee,
      draft: payload,
    },
  };
};

export const onClearEmployeeDraft = (state: EmployeesState) => () => {
  return {
    ...state,
    employee: {
      ...state.employee,
      draft: null,
    },
  };
};

export const onAddEmployee = (state: EmployeesState) => ({ payload }: Object) => ({
  ...state,
  employee: {
    ...state.employee,
    modals: {
      ...state.employee.modals,
      addEmployee: {
        ...state.employee.modals.addEmployee,
        employee: payload,
      },
    },
  },
});

export const onSetEmployeesSort = (state: EmployeesState) => ({
  payload,
}: $Exact<{ action: string, payload: Object }>) => {
  return {
    ...state,
    employee: {
      ...startRequest(state.employee),
      list: {
        ...state.employee.list,
        pagination: {
          ...state.employee.list.pagination,
          sort: {
            ...state.employee.list.pagination.sort,
            orders: transformSort(payload.sort),
          },
        },
      },
    },
  };
};

export const onToggleContactInfoModal = (state: EmployeesState) => ({ payload }: Object) => ({
  ...state,
  employee: {
    ...state.employee,
    modals: {
      ...state.employee.modals,
      contactInfo: {
        visible: payload,
      },
    },
  },
});

export const onToggleHomePageSettings = (state: EmployeesState) => ({ payload }: Object) => ({
  ...state,
  employee: {
    ...state.employee,
    modals: {
      ...state.employee.modals,
      homePageSettings: {
        visible: payload,
      },
    },
  },
});

export const onToggleChangePasswordModal = (state: EmployeesState) => ({ payload }: Object) => ({
  ...state,
  employee: {
    ...state.employee,
    modals: {
      ...state.employee.modals,
      changePassword: {
        visible: payload,
      },
    },
  },
});

export const onToggleAbsenceDetailsModal = (state: EmployeesState) => ({ payload }: Object) => ({
  ...state,
  employee: {
    ...state.employee,
    modals: {
      ...state.employee.modals,
      absenceDetails: {
        visible: payload,
      },
    },
  },
});

export const onChangeEmployeeFilterInitialValues = (state: EmployeesState) => ({
  payload,
}: Object) => ({
  ...state,
  employee: {
    ...state.employee,
    employeeFilterInitialValues: payload,
  },
});
